import React, { FC } from 'react'
import { Box } from '@chakra-ui/react'
import { Trans, t } from '@lingui/macro'

import { CertificateTemplatePageHeader } from './CertificateTemplatePageHeader'
import { linkBuilder } from 'shared/linkBuilder'
import { navigateTo } from '../../../app/util/appHistory'
import { Page, PagePanel } from '../../../components/common/page/Page'
import PageHeader from '../../../components/common/page/header/PageHeader'

export const CertificateTemplatesPage: FC = () => {
  return (
    <Page className="Certifications Certifications--templates --with-heading">
      <PageHeader className="PageHeader" title={t`Manage templates`} />
      <div className="Page Subheader Page__inner">
        <Trans>
          These templates will be used to generate certifications for users
        </Trans>
      </div>
      <PagePanel>
        <Box pr={4} pl={4}>
          <CertificateTemplatePageHeader
            onSelect={(value) =>
              navigateTo(linkBuilder.certificationsTemplates(value))
            }
            allowCreateNew
          />
        </Box>
      </PagePanel>
    </Page>
  )
}
